import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import { useTranslations } from '../../locales/useTranslations';


const AppDevelopmentFAQ = () => {
    const { t } = useTranslations();

    return (
        <section className="faq-area ptb-100 bg-color-f4f5fe" >
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-7 col-md-12">
                        <div className="faq-accordion">
                            <h2><span>{t('appDevelopment_faq_title')}</span></h2>

                            <div className="native-accordion">
                                <details open>
                                    <summary>
                                        {t('appDevelopment_faq_q1')}
                                    </summary>
                                    <div className="accordion-content">
                                        <p>
                                            {t('appDevelopment_faq_a1')}
                                        </p>
                                    </div>
                                </details>

                                <details>
                                    <summary>
                                        {t('appDevelopment_faq_q2')}
                                    </summary>
                                    <div className="accordion-content">
                                        <p>
                                            {t('appDevelopment_faq_a2')}
                                        </p>
                                    </div>
                                </details>

                                <details>
                                    <summary>
                                        {t('appDevelopment_faq_q3')}
                                    </summary>
                                    <div className="accordion-content">
                                        <p>
                                            {t('appDevelopment_faq_a3')}
                                        </p>
                                    </div>
                                </details>

                                <details>
                                    <summary>
                                        {t('appDevelopment_faq_q4')}
                                    </summary>
                                    <div className="accordion-content">
                                        <p>
                                            {t('appDevelopment_faq_a4')}
                                        </p>
                                    </div>
                                </details>

                                <details>
                                    <summary>
                                        {t('appDevelopment_faq_q5')}
                                    </summary>
                                    <div className="accordion-content">
                                        <p>
                                            {t('appDevelopment_faq_a5')}
                                        </p>
                                    </div>
                                </details>

                                <details>
                                    <summary>
                                        {t('appDevelopment_faq_q6')}
                                    </summary>
                                    <div className="accordion-content">
                                        <p>
                                            {t('appDevelopment_faq_a6')}
                                        </p>
                                    </div>
                                </details>

                                <details>
                                    <summary>
                                        {t('appDevelopment_faq_q7')}
                                    </summary>
                                    <div className="accordion-content">
                                        <p>
                                            {t('appDevelopment_faq_a7')}
                                        </p>
                                    </div>
                                </details>

                                <details>
                                    <summary>
                                        {t('appDevelopment_faq_q8')}
                                    </summary>
                                    <div className="accordion-content">
                                        <p>
                                            {t('appDevelopment_faq_a8')}
                                        </p>
                                    </div>
                                </details>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-5 col-md-12">
                        <div className="faq-image">
                            <Player
                                autoplay
                                loop
                                src="/images/lottie/faq.json"
                                style={{ height: '300px' }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AppDevelopmentFAQ;